/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useEffect, useState } from 'react';
import {
  Grid,
  Table,
  TableEditColumn,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import { Box, fade, Paper, Typography, withStyles } from '@material-ui/core';
import { DataTypeProvider, EditingState } from '@devexpress/dx-react-grid';
import { accountFormatter, currencyFormatter } from './colorFormat';
import { CommandSmall } from './CommandSmall';
import { getColumns } from '../common/columns';
import { Getter } from '@devexpress/dx-react-core';
import PopupEditing from './PopupEditing';
import PopupKaidItem from '../pubups/PopupKaidItem';

export const getRowId = (row: any) => row.index;

const NumberTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={({ value }) => (
      <Typography variant="subtitle2">{Number(value) + 1}</Typography>
    )}
    {...props}
  />
);

const styles = (theme) => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade(theme.palette.primary.main, 0.1),
    },
  },
});

const TableComponentBase = ({ classes, ...restProps }) => (
  <Table.Table {...restProps} className={classes.tableStriped} />
);

export const TableComponent = withStyles(styles, { name: 'TableComponent' })(
  TableComponentBase
);

export default function KaidsSingleTable({
  rows,
  removeItem,
  isRTL,
  words,
  editItem,
  accounts,
  departments,
  employees,
  resourses,
  contracts,
  customers,
  suppliers,
  acustomer,
  asupplier,
  acontract,
  aresourse,
  aemployee,
  adepartment,
  user,
}: any) {
  const col = getColumns({ isRTL, words });
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    const cul = [
      { name: 'index', title: words.no },
      { name: 'acc', title: words.account },
      { name: 'amountDebit', title: words.amountDebit },
      { name: 'amountCredit', title: words.amountCredit },
      acustomer && col.customer,
      asupplier && col.supplier,
      acontract && col.contract,
      adepartment && col.department,
      aemployee && col.employee,
      aresourse && col.resourse,
      { name: 'desc', title: words.description },
    ].filter((x) => x);

    setColumns(cul);
  }, [acustomer, asupplier]);

  const commitChanges = async ({ deleted }) => {
    if (deleted) {
      const index = deleted[0];
      removeItem(index);
    }
  };

  const renderEmpty = () => {
    return <Box display="flex"></Box>;
  };
  return (
    <Paper
      elevation={4}
      style={{
        height: 265,
        overflow: 'auto',
        // backgroundColor: 'red',
        marginRight: 20,
      }}
    >
      {rows && (
        <Grid rows={rows} columns={columns} getRowId={getRowId}>
          <EditingState onCommitChanges={commitChanges} />
          <Table
            noDataCellComponent={renderEmpty}
            // columnExtensions={tableColumnExtensions}
            tableComponent={TableComponent}
          />
          <DataTypeProvider
            for={['amountDebit', 'amountCredit']}
            formatterComponent={currencyFormatter}
          ></DataTypeProvider>
          <NumberTypeProvider for={['index']} />
          <DataTypeProvider
            for={['acc']}
            formatterComponent={(props) =>
              accountFormatter(props, accounts, isRTL)
            }
          ></DataTypeProvider>
          <TableEditColumn
            showDeleteCommand
            showEditCommand
            commandComponent={CommandSmall}
          ></TableEditColumn>
          <PopupEditing editAction={editItem}>
            <PopupKaidItem
              isRTL={isRTL}
              words={words}
              accounts={accounts}
              departments={departments}
              employees={employees}
              resourses={resourses}
              contracts={contracts}
              customers={customers}
              suppliers={suppliers}
              acustomer={acustomer}
              asupplier={asupplier}
              acontract={acontract}
              aresourse={aresourse}
              aemployee={aemployee}
              adepartment={adepartment}
              user={user}
            ></PopupKaidItem>
          </PopupEditing>
          <TableHeaderRow
            titleComponent={({ children }) => {
              return (
                <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                  {children}
                </Typography>
              );
            }}
          />
          <Getter
            name="tableColumns"
            computed={({ tableColumns }) => {
              const result = [
                {
                  key: 'editCommand',
                  type: TableEditColumn.COLUMN_TYPE,
                  width: 70,
                },
                ...tableColumns.filter(
                  (c: any) => c.type !== TableEditColumn.COLUMN_TYPE
                ),
              ];
              return result;
            }}
          />
        </Grid>
      )}
    </Paper>
  );
}
